import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NotFoundComponent } from './not-found/not-found.component';
import { AppViewComponent } from './draft-page/app-view/app-view.component';
import { TokenGuard } from './core/guards';
import { ImportComponent } from './import-page/import/import.component';
import { CalibrationAdminPageComponent } from './admin-page/calibration-admin-page/calibration-admin-page.component';
import { IsNotCalibratedReasonsManagementPageComponent } from './admin-page/is-not-calibrated-reasons-management-page/is-not-calibrated-reasons-management-page.component';
import { GridicsUsesTagsManagementPageComponent } from './admin-page/gridics-uses-tags-management-page/gridics-uses-tags-management-page.component';
import { ProductFeaturesGuard } from './core/guards/product-features.guard';
import { ProductFeatures } from 'src/shared/auth/enums/product-features-enum';
import { AccessDeniedComponent } from './components/access-denied/access-denied.component';
import { ZoningCodesImportTabComponent } from './import-page/zoning-codes-import-tab/zoning-codes-import-tab.component';

const routes: Routes = [
    {
        path: 'draft',
        children: [
            {
                path: '',
                redirectTo: '/',
                pathMatch: 'full'
            },
            {
                path: ':token',
                canActivate: [TokenGuard],
                children: [
                    {
                        path: '',
                        redirectTo: 'zones',
                        pathMatch: 'full'
                    },
                    {
                        path: 'zones',
                        children: [
                            {
                                path: '',
                                redirectTo: 'general',
                                pathMatch: 'full'
                            },
                            {
                                path: 'general',
                                component: AppViewComponent
                            },
                            {
                                path: 'uses',
                                component: AppViewComponent
                            },
                            {
                                path: 'parking',
                                component: AppViewComponent
                            },
                            {
                                path: 'use-capacity',
                                component: AppViewComponent
                            },
                            {
                                path: 'bonus',
                                component: AppViewComponent
                            },
                            {
                                path: 'building-typology',
                                component: AppViewComponent
                            }
                        ]
                    },
                    {
                        path: 'overlays',
                        children: [
                            {
                                path: '',
                                redirectTo: 'general',
                                pathMatch: 'full'
                            },
                            {
                                path: 'general',
                                component: AppViewComponent
                            },
                            {
                                path: 'uses',
                                component: AppViewComponent
                            },
                            {
                                path: 'parking',
                                component: AppViewComponent
                            },
                            {
                                path: 'use-capacity',
                                component: AppViewComponent
                            },
                            {
                                path: 'bonus',
                                component: AppViewComponent
                            },
                            {
                                path: 'building-typology',
                                component: AppViewComponent
                            }
                        ]
                    },
                    {
                        path: 'typologies',
                        children: [
                            {
                                path: '',
                                redirectTo: 'general',
                                pathMatch: 'full'
                            },
                            {
                                path: 'general',
                                component: AppViewComponent
                            },
                            {
                                path: 'uses',
                                component: AppViewComponent
                            },
                            {
                                path: 'parking',
                                component: AppViewComponent
                            },
                            {
                                path: 'use-capacity',
                                component: AppViewComponent
                            },
                            {
                                path: 'bonus',
                                component: AppViewComponent
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        path: 'import',
        children: [
            {
                path: '',
                redirectTo: '/notFound',
                pathMatch: 'full'
            },
            {
                path: 'zoning-code',
                children: [
                    {
                        path: ':token',
                        canActivate: [TokenGuard],
                        children: [
                            {
                                path: '',
                                redirectTo: 'zones',
                                pathMatch: 'full'
                            },
                            {
                                path: 'zones',
                                children: [
                                    {
                                        path: '',
                                        redirectTo: 'general',
                                        pathMatch: 'full'
                                    },
                                    {
                                        path: 'general',
                                        component: ImportComponent
                                    },
                                    {
                                        path: 'uses',
                                        component: ImportComponent
                                    },
                                    {
                                        path: 'parking',
                                        component: ImportComponent
                                    },
                                    {
                                        path: 'use-capacity',
                                        component: ImportComponent
                                    },
                                    {
                                        path: 'bonus',
                                        component: ImportComponent
                                    },
                                    {
                                        path: 'building-typology',
                                        component: ImportComponent
                                    }
                                ]
                            },
                            {
                                path: 'overlays',
                                children: [
                                    {
                                        path: '',
                                        redirectTo: 'general',
                                        pathMatch: 'full'
                                    },
                                    {
                                        path: 'general',
                                        component: ImportComponent
                                    },
                                    {
                                        path: 'uses',
                                        component: ImportComponent
                                    },
                                    {
                                        path: 'parking',
                                        component: ImportComponent
                                    },
                                    {
                                        path: 'use-capacity',
                                        component: ImportComponent
                                    },
                                    {
                                        path: 'bonus',
                                        component: ImportComponent
                                    },
                                    {
                                        path: 'building-typology',
                                        component: ImportComponent
                                    }
                                ]
                            },
                            {
                                path: 'typologies',
                                children: [
                                    {
                                        path: '',
                                        redirectTo: 'general',
                                        pathMatch: 'full'
                                    },
                                    {
                                        path: 'general',
                                        component: ImportComponent
                                    },
                                    {
                                        path: 'uses',
                                        component: ImportComponent
                                    },
                                    {
                                        path: 'parking',
                                        component: ImportComponent
                                    },
                                    {
                                        path: 'use-capacity',
                                        component: ImportComponent
                                    },
                                    {
                                        path: 'bonus',
                                        component: ImportComponent
                                    }
                                ]
                            },
                            {
                                path: 'zone-descriptions',
                                component: ImportComponent
                            },
                            {
                                path: 'calibration-set-table-field-attributes',
                                component: ImportComponent
                            }
                        ]
                    }
                ]
            },
            {
                path: 'zoning-codes',
                component: ZoningCodesImportTabComponent,
                pathMatch: 'full'
            }
        ]
    },
    {
        path: 'admin',
        component: CalibrationAdminPageComponent,
        canActivate: [ProductFeaturesGuard],
        data: { productFeature: ProductFeatures.ECI_CALIBRATION_ADMIN_PAGE },
        children: [
            {
                path: '',
                redirectTo: 'is-not-calibrated-reasons',
                pathMatch: 'full'
            },
            {
                path: 'is-not-calibrated-reasons',
                component: IsNotCalibratedReasonsManagementPageComponent
            },
            {
                path: 'gridics-uses-tags',
                component: GridicsUsesTagsManagementPageComponent
            }
        ]
    },
    {
        path: 'access-denied',
        component: AccessDeniedComponent
    },
    {
        path: '**',
        component: NotFoundComponent
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {}
